import { stringify } from '../libs/queryString';
import { Template } from '../../types/api';

export function getEditorLink({
  template,
  editorSessionId,
  isUseMetaSiteCreator,
  isNewIntroEnableAppSuggestions,
}: {
  template: Template;
  editorSessionId: string;
  isUseMetaSiteCreator: boolean;
  isNewIntroEnableAppSuggestions: boolean;
}): string {
  const { siteId, metaSiteId } = template;
  if (isUseMetaSiteCreator) {
    return `https://manage.wix.com/edit-template/${isNewIntroEnableAppSuggestions ? 'from-intro' : 'from'}?${stringify({
      originTemplateId: metaSiteId,
      editorSessionId,
    })}`;
  }
  return `https://editor.wix.com/html/editor/web/renderer/new?${stringify({ siteId, metaSiteId, editorSessionId })}`;
}

export function getViewerLink({
  template,
  language,
  originUrl,
  clickedElement = 'view_button',
}: {
  template: Template;
  language: string;
  originUrl: string;
  clickedElement?: 'view_button' | 'thumbnail';
}): string {
  const { siteId, metaSiteId, id } = template;
  return `https://${language === 'en' ? 'www' : language}.wix.com/website-template/view/html/${id}?${stringify({
    siteId,
    metaSiteId,
    originUrl,
    tpClick: clickedElement,
  })}`;
}

export function getEditorLinkRegExp(siteId: string): RegExp {
  const uuidRegex = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
  const regExp = new RegExp(
    `^https:\\/\\/editor\\.wix\\.com\\/html\\/editor\\/web\\/renderer\\/new\\?siteId=${siteId}&editorSessionId=${uuidRegex}`,
  );

  return regExp;
}
